import React from 'react';
import { useSelector } from 'react-redux';
import { AnchorWithLink } from 'atoms/Anchor';
import ImageComponent from 'atoms/Image';
import MapImage from 'styles/staticAssets/images/Map.svg';
import { ButtonComp } from 'atoms/Buttons';
import SEARCH_STORE_CONSTANTS from '../Constants/SearchStoreConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

export const addressSpacing = str => {
  if (str.includes(',') === true) {
    return str.replace(',', ', ');
  } else {
    return str;
  }
};

const SavedAddress = props => {
  const { onMapClickHandler, startOrderFormSavedAddress } = props;
  const mapText = 'Map';
  const { SAVED_ADDRESS, START_ORDER_TEXT } = SEARCH_STORE_CONSTANTS;
  const { savedAddresses } = useSelector(data => data.profileReducer);
  const defaultAddress = savedAddresses.filter(({ isPrimary }) => isPrimary);
  const addressToShowOnMap = defaultAddress[0]?.addressLines?.join(' ');
  const startOrderButtonClickHandler = (e, address) => {
    const { latitude, longitude } = address.location;
    const userPosition = { userLat: latitude, userLong: longitude };
    const finalAddress =
      address?.addressLines?.reduce((p, c) => p + ' ' + c) +
      ', ' +
      address?.city +
      ', ' +
      address?.state +
      ', ' +
      address?.country;

    startOrderFormSavedAddress(finalAddress, userPosition);
  };

  return (
    <React.Fragment>
      <div>
        <div className='savedAddress-store-count'>
          <span className='saved-address-count-title'>{`${translateWithI18Next(SAVED_ADDRESS)}${
            savedAddresses.length > 1 ? `es  ` : ''
          } (${savedAddresses.length})`}</span>
          <div data-testid='saved-map-link' onClick={e => onMapClickHandler(e, '', addressToShowOnMap)}>
            <AnchorWithLink className='map-link'>
              <span>
                <ImageComponent data-testid='' srcFile={MapImage} alt={'map'} className='map-img' />
              </span>
              {mapText}
            </AnchorWithLink>
          </div>
        </div>
        {savedAddresses.map(item => {
          return (
            <div className='savedAddress-module-card'>
              <div className='inside-card'>
                <div className='address-section'>
                  <div className='address-type'>{item.name} : </div>
                  <div className='address'>
                    {item?.addressLines[1] && <span> {addressSpacing(item?.addressLines[1])}, </span>}
                    {item?.addressLines[0] && <span> {addressSpacing(item?.addressLines[0])}, </span>}
                    {item?.city && <span> {item?.city}, </span>}
                    {item?.state && <span> {item?.state} - </span>}
                    {item?.pinCode && <span> {item?.pinCode}, </span>}
                    {item?.country && <span> {item?.country} </span>}
                  </div>
                </div>
                <div>
                  <ButtonComp
                    className='button redButton search-store-card-btn'
                    onClickHandler={e => startOrderButtonClickHandler(e, item)}
                    data-testid='savedaddress-click-test'
                  >
                    {translateWithI18Next(START_ORDER_TEXT)}
                  </ButtonComp>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};
export default SavedAddress;
